<template>
	<v-dialog v-model="setdialog.dialog" max-width="600px" persistent content-class="common-modal">
		<v-card class="reseveDialog">
			<!-- 내용 -->
			<!-- <div class="title">
			</div> -->

			<div class="dialog-content">
				<div id="divNewLine">{{ setdialog.text }}</div>
				<div v-if="setdialog.done">
					<v-img min-height="130px" class="mb-5" src="/image/end_ok.jpg"></v-img>
					<v-divider class="mb-5" />
					<p class="doneTxt">코로나 예방을 위한 자가 문진표 작성이 완료되었습니다.</p>
				</div>
				<!-- bottom -->
				<!-- 버튼 -->
				<div class="bottom">
					<v-layout justify-end>
						<btn v-if="$route.name === 'temperatureCheck'" btn_txt="확인" class="ml-2" :btn="saveBtn" @click="close"></btn>
						<btn v-else btn_txt="확인" class="ml-2" :btn="saveBtn" @click="close"></btn>
					</v-layout>
				</div>
				<a class="hideClose" id="closekakao" onclick="window.close(); location.href = 'kakaotalk://inappbrowser/close'; return false;"
					>창 닫기</a
				>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import { btn } from '@/components/index'
export default {
	data() {
		return {
			saveBtn: {
				class: 'blueOkBtn',
				small: true,
				width: '10px',
			},
			model: 0,
		}
	},
	props: {
		setdialog: Object,
		infoInsert: Function,
	},
	methods: {
		close() {
			this.setdialog.dialog = false
			if (this.$route.name === 'temperatureCheck' && this.setdialog.text === '') {
				window.open('', '_self').close()
				document.getElementById('closekakao').click()
			}
			if (this.setdialog.nextStep) {
				this.infoInsert()
			}
		},
	},
	components: {
		btn,
	},
}
</script>
<style lang="scss" scoped>
.reseveDialog {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #fdc85a;
		padding: 0 16px;

		h2 {
			color: white;
		}

		.title-icon {
			color: white;
		}
	}

	.dialog-content {
		padding: 20px 24px;
		font-weight: 500;
		font-size: 15px;
		color: #a7a7a7;
	}
	.bottom {
		display: flex;
		margin-top: 20px;
	}
	.doneTxt {
		font-size: 14px;
		font-weight: 500;
	}
}
.red-dot {
	font-size: 24px;
	color: #ff5252;
	margin-right: 10px;
}
.hideClose {
	display: none;
}
#divNewLine {
	white-space: pre-wrap;
}
</style>
